import type { ReactNode } from "react";
import type { FlagCategory } from "./flagConstants.";
import { CATEGORY_CONFIG } from "./flagConstants.";
import {
  IconId,
  IconAlertTriangle,
  IconEyeOff,
  IconLock,
  IconTool,
} from "@tabler/icons-react";

interface Props {
  selected: FlagCategory | null;
  onSelect: (c: FlagCategory) => void;
}

const ICONS: Record<FlagCategory, ReactNode> = {
  PII: <IconId className="chip-icon" size={16} />,
  Conduct: <IconAlertTriangle className="chip-icon" size={16} />,
  Witness: <IconEyeOff className="chip-icon" size={16} />,
  Restricted: <IconLock className="chip-icon" size={16} />,
  Technical: <IconTool className="chip-icon" size={16} />,
};

const CHIP_CLASS: Record<FlagCategory, string> = {
  PII: "pii",
  Conduct: "conduct",
  Witness: "witness",
  Restricted: "restricted",
  Technical: "technical",
};

export function CategoryChips({ selected, onSelect }: Props) {
  return (
    <div className="reason-chips">
      {(Object.keys(CATEGORY_CONFIG) as FlagCategory[]).map((cat) => {
        const { label } = CATEGORY_CONFIG[cat];
        const chipCls = CHIP_CLASS[cat];
        const isSelected = selected === cat;
        return (
          <div
            key={cat}
            role="button"
            tabIndex={0}
            onClick={() => onSelect(cat)}
            onKeyDown={(e) => e.key === "Enter" && onSelect(cat)}
            className={`chip ${chipCls} ${isSelected ? "selected" : ""}`}
          >
            {ICONS[cat]}
            <span className="chip-lbl">{label}</span>
          </div>
        );
      })}
    </div>
  );
}
